import React from 'react';
import SolarCalculator from '../components/solarcalculator';

export default function SolarPage() {
  return <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}><SolarCalculator /></div>;
}